import Vue from 'vue';
import Vuex from 'vuex';
import { GET_USED_TOWNS, APPLY_FILTERS, API_URL, SAVE_USED_TOWNS, GET_PUBLIC_PROPERTIES, SAVE_PUBLIC_PROPERTIES, GET_PRICE_RANGES, GET_PUBLIC_PROPERTY, SAVE_PUBLIC_PROPERTY } from './constants'
import axios from 'axios'
import to from 'await-to-js'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    properties: [],
    usedTowns: [],
    filters : {
      towns : [],
      reference : "",
      isForRent : true,
      priceTop : 0,
      priceDown: 0,
      restRooms : 0,
      bathrooms : 0
    }
  },
  mutations: {
    [SAVE_USED_TOWNS](state, towns) {
      state.usedTowns = towns;
    },
    [SAVE_PUBLIC_PROPERTIES](state, properties) {
      state.properties = properties;
    },
    [APPLY_FILTERS](state, searchCriteria) {
      state.filters = searchCriteria;
    }
  },
  actions: {
    async [GET_PUBLIC_PROPERTY](state, propertyId) {
      var [err, property] = await to(axios.get(`${API_URL}/PublicProperties/${propertyId}`))

      return property.data;
    },
    async [GET_USED_TOWNS](state) {
      var [err, towns] = await to(axios.get(`${API_URL}/Locations/UsedTowns`))

      state.commit(SAVE_USED_TOWNS, towns.data);
    },
    async [GET_PUBLIC_PROPERTIES](state, searchCriteria) {
      var stateIdsQueryString = "";

      state.commit(APPLY_FILTERS, searchCriteria);

      if (typeof searchCriteria.towns === "string") 
      {
        stateIdsQueryString += `&towns=${searchCriteria.towns}`; 
      } 
      else
      {
        searchCriteria.towns.forEach(function(element) {
          stateIdsQueryString += `&towns=${element}`; 
        })  
      }

      var [err, properties] = await to(axios.get(`${API_URL}/PublicProperties?page=${searchCriteria.page}&size=${searchCriteria.size}${stateIdsQueryString}&isForRent=${searchCriteria.isForRent}&reference=${searchCriteria.reference}&bedrooms=${searchCriteria.bedrooms}&bathrooms=${searchCriteria.bathrooms}&maxPrice=${searchCriteria.maxPrice}&minPrice=${searchCriteria.minPrice}`, ))

      state.commit(SAVE_PUBLIC_PROPERTIES, properties.data);
    },
    async [GET_PRICE_RANGES](state) {
      var [err, ranges] = await to(axios.get(`${API_URL}/PublicProperties/PriceRanges`));

      return ranges.data;
    }
  },
});
